/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfiguredGraphUpdate } from '../../models/configured-graph-update';

export interface UpdateConfiguredGraph$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the configured graph
 */
  graphUid: string;
  
    /**
     * The configured graph update object
     */
    body: ConfiguredGraphUpdate
}

export function updateConfiguredGraph(http: HttpClient, rootUrl: string, params: UpdateConfiguredGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateConfiguredGraph.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('graphUid', params.graphUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateConfiguredGraph.PATH = '/stations/{uid}/graph/configured/{graphUid}';
